var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from "react";
import { MessageHelper } from "../../helpers/MessageHelper";
import styles from "./account.module.scss";
import { AIACommand } from "../../helpers/AIACommand";
import { KeycloakContext } from "../../helpers/KeycloakContext";
import { AccountServiceContext } from "../../services/account-service/AccountServiceContext";
import LightweightButton from "../../components/button/LightweightButton";
import LightweightLabel from "../../components/label/LightweightLabel";
import LightweightCard from "../../components/card/LightweightCard";
import LightweightBox from "../../components/box/LightweightBox";
import { WebauthnRegistrationDialog } from "../credentials/WebauthnRegistrationDialog";
import TimeUtil from "../../helpers/TimeUtil";
const staticConfig = require("../../static.config.json");
const DEFAULT_STATE = {
    errors: {
        username: "",
        firstName: "",
        lastName: "",
        email: ""
    },
    formFields: {
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        attributes: {}
    }
};
const renderAccountPageHeader = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.pageHeaderContainer },
            React.createElement("h1", { "aria-label": "heading" },
                React.createElement(MessageHelper, { msgKey: "personalInfoHtmlTitle" })))));
};
const renderAccountUserDataForm = (state, handleEmailChange, getPasswordUpdateAction, keycloak) => {
    var _a, _b;
    const passwordUpdateAction = getPasswordUpdateAction();
    const renderUpdatePasswordButton = passwordUpdateAction && keycloak.hasRealmRole("webauthn_user");
    const subHeadlineWithPadding = `${styles.accountHeaderSubtext} ${styles.subHeadlinePadding}`;
    return (React.createElement(React.Fragment, null,
        React.createElement(LightweightCard, { className: styles.loginFormCard },
            React.createElement("h3", { className: styles.accountHeader },
                React.createElement(MessageHelper, { msgKey: keycloak.hasRealmRole("webauthn_user") ? "changeEmailAndPasswordHeadline" : "changeEmailHeadline" })),
            React.createElement(LightweightLabel, { className: subHeadlineWithPadding },
                React.createElement(MessageHelper, { msgKey: "changeEmailAndUsernameSubHeadline" })),
            React.createElement(LightweightLabel, { className: styles.accountHeaderSubtext },
                React.createElement(MessageHelper, { msgKey: "emailAddress" })),
            React.createElement(LightweightBox, { className: styles.accountDetailContainer, "aria-label": "user-email-label" },
                React.createElement("b", null, (_a = state.formFields) === null || _a === void 0 ? void 0 : _a.email)),
            React.createElement(LightweightLabel, { className: styles.accountHeaderSubtext },
                React.createElement(MessageHelper, { msgKey: "userId" })),
            React.createElement(LightweightBox, { className: styles.accountDetailContainer, "aria-label": "user-name-label" },
                React.createElement("b", { "data-testid": "username" }, (_b = state.formFields) === null || _b === void 0 ? void 0 : _b.username)),
            React.createElement("div", { className: styles.accountButtonContainer },
                React.createElement(LightweightButton, { "aria-label": "update-email-button", color: "primary", onClick: () => handleEmailChange() },
                    React.createElement(MessageHelper, { msgKey: "updateEmail" })),
                renderUpdatePasswordButton &&
                    React.createElement(LightweightButton, { "aria-label": "update-email-button", color: "primary", onClick: () => {
                            passwordUpdateAction.execute();
                        } },
                        React.createElement(MessageHelper, { msgKey: "updatePassword" }))))));
};
const AccountDataPage = (props) => {
    const { updateEmail, initialState = DEFAULT_STATE } = props;
    const keycloak = useContext(KeycloakContext);
    const context = useContext(AccountServiceContext);
    const [state, setState] = useState(initialState);
    const accountService = useContext(AccountServiceContext);
    const [credentialContainers, updateCredentialContainers] = useState(new Map());
    const renewalOffsetMillis = staticConfig.maxDaysBeforeCertificateRenewalRequired * 24 * 60 * 60 * 1000;
    const getCredentialContainers = () => __awaiter(void 0, void 0, void 0, function* () {
        const containers = yield accountService.doGet("/credentials");
        const allContainers = new Map();
        containers.forEach(container => {
            let categoryMap = allContainers.get(container.category);
            if (!categoryMap) {
                categoryMap = new Map();
                allContainers.set(container.category, categoryMap);
            }
            categoryMap.set(container.type, container);
        });
        updateCredentialContainers(allContainers);
    });
    useEffect(() => {
        const fetchPersonalInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            const formFields = yield context.doGet("/");
            if (!formFields.attributes) {
                formFields.attributes = { locale: [locale] };
            }
            else if (!formFields.attributes.locale) {
                formFields.attributes.locale = [locale];
            }
            setState({ errors: null, formFields: formFields });
        });
        const initializeData = () => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchPersonalInfo();
            yield getCredentialContainers();
        });
        initializeData().catch(e => {
            throw new Error(e);
        });
    }, []);
    const getPasswordCredContainer = () => {
        var _a;
        return (_a = credentialContainers.get("basic-authentication")) === null || _a === void 0 ? void 0 : _a.get("password");
    };
    const handleEmailChange = () => {
        updateEmail ? updateEmail.execute() : new AIACommand(keycloak, "change_email").execute();
    };
    const getPasswordUpdateAction = () => {
        var _a;
        return new AIACommand(keycloak, (_a = getPasswordCredContainer()) === null || _a === void 0 ? void 0 : _a.updateAction, baseUrl);
    };
    const createUpdatePasswordAction = () => {
        const redirectUrl = `${baseUrl}?showWebauthnRegistrationDialog=true`;
        const passwordCredContainer = getPasswordCredContainer();
        const action = (passwordCredContainer === null || passwordCredContainer === void 0 ? void 0 : passwordCredContainer.createAction) ||
            (!keycloak.hasRealmRole("webauthn_user") && (passwordCredContainer === null || passwordCredContainer === void 0 ? void 0 : passwordCredContainer.updateAction));
        return action ? new AIACommand(keycloak, action, redirectUrl) : null;
    };
    const createSetUpAction = (credContainer) => {
        if (credContainer.type === "client-certificate" && credContainer.userCredentialMetadatas.length === 1) {
            return null;
        }
        if (credContainer === null || credContainer === void 0 ? void 0 : credContainer.createAction) {
            return new AIACommand(keycloak, credContainer.createAction, baseUrl);
        }
        return null;
    };
    const getFidoLabels = (credContainer) => {
        return credContainer.userCredentialMetadatas.map((credential, index) => {
            return React.createElement(LightweightBox, { key: `fido-label-${index}`, className: styles.blockElement, "aria-label": "user-fido" },
                React.createElement("b", null, credential.credential.userLabel),
                credential.credential.strCreatedDate && React.createElement("div", null,
                    "Angelegt am: ",
                    credential.credential.strCreatedDate));
        });
    };
    const renderFidoContainer = (credContainer) => {
        const currentParams = new URLSearchParams(document.location.search);
        const labels = getFidoLabels(credContainer);
        const hasToken = (labels === null || labels === void 0 ? void 0 : labels.length) > 0;
        return React.createElement(React.Fragment, null,
            React.createElement(LightweightCard, { key: "fido-container", className: styles.loginFormCard },
                React.createElement("h3", { className: styles.accountHeader },
                    React.createElement(MessageHelper, { msgKey: "webauthn-display-name" })),
                React.createElement(LightweightLabel, { className: styles.accountHeaderSubtext },
                    React.createElement(MessageHelper, { msgKey: hasToken ? "webauthnRegisteredTokensHint" : "webauthnNoRegisteredTokensHint" })),
                labels,
                React.createElement("div", { className: styles.accountButtonContainer },
                    React.createElement("div", { "aria-label": "webauthn-type-action" },
                        React.createElement(WebauthnRegistrationDialog, { hasTokens: hasToken, showWebauthnRegistrationDialog: 'true' === currentParams.get("showWebauthnRegistrationDialog"), credDisplayName: "Token", updatePasswordAction: createUpdatePasswordAction(), setupAction: createSetUpAction(credContainer) })))));
    };
    const renderCertificateContainer = (credentialContainer) => {
        var _a;
        const updateAction = credentialContainer.updateAction ?
            new AIACommand(keycloak, credentialContainer.updateAction) : null;
        const downloadAction = credentialContainer.downloadAction ?
            new AIACommand(keycloak, credentialContainer.downloadAction) : null;
        const createAction = createSetUpAction(credentialContainer);
        const html = [];
        (_a = credentialContainer.userCredentialMetadatas) === null || _a === void 0 ? void 0 : _a.map((c, index) => {
            const { credential } = c;
            const credentialData = JSON.parse(credential.credentialData);
            const strValidUntilDate = TimeUtil.format(credentialData.validUntil);
            const showRenewalNotice = (credentialData.validUntil - renewalOffsetMillis) < Date.now();
            html.push(React.createElement(React.Fragment, null,
                React.createElement(LightweightLabel, { className: styles.accountHeaderSubtext, key: `cred-label-${credential.id}`, "aria-label": "cred-label" }, credential.userLabel),
                React.createElement(LightweightBox, { key: `cred-valid-until-${credential.id}`, className: styles.accountDetailContainer, "aria-label": "cred-valid-until" }, strValidUntilDate ? (React.createElement(React.Fragment, null,
                    React.createElement("strong", null,
                        React.createElement(MessageHelper, { msgKey: "credentialValidUntil" }),
                        ": ",
                        strValidUntilDate))) : null),
                React.createElement("div", { className: styles.accountButtonContainer },
                    updateAction && credentialContainer.userCredentialMetadatas.length >= 1 &&
                        React.createElement(LightweightButton, { className: styles.actionButton, "aria-label": "update-cert-button", color: "primary", onClick: () => updateAction.execute() },
                            React.createElement(MessageHelper, { msgKey: "updateCertificate" })),
                    downloadAction && credentialContainer.userCredentialMetadatas.length >= 1 &&
                        React.createElement(React.Fragment, null,
                            showRenewalNotice ? React.createElement("span", null,
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement(MessageHelper, { msgKey: "renewalNotice" })) : "",
                            React.createElement(LightweightButton, { "aria-label": "download-cert-button", color: "primary", onClick: () => {
                                    downloadAction.execute();
                                } },
                                React.createElement(MessageHelper, { msgKey: "downloadCertificate" }))))));
        });
        return React.createElement(React.Fragment, null,
            React.createElement(LightweightCard, { id: credentialContainer.type, className: styles.loginFormCard },
                React.createElement("h3", null,
                    React.createElement(MessageHelper, { msgKey: "client-certificate-help" })),
                React.createElement(LightweightLabel, { className: styles.accountHeaderSubtext },
                    React.createElement(MessageHelper, { msgKey: "certificateSubHeadline" })),
                createAction &&
                    React.createElement("div", { className: styles.accountButtonContainer },
                        React.createElement(LightweightButton, { onClick: () => createAction.execute(), color: "primary", className: styles.actionButton },
                            React.createElement(MessageHelper, { msgKey: "acquireCertificate" }))),
                html));
    };
    const renderType = (credTypeMap) => {
        const html = [];
        for (const credType of credTypeMap.keys()) {
            const currentContainer = credTypeMap.get(credType);
            switch (credType) {
                case "webauthn": {
                    html.push(React.createElement(React.Fragment, { key: `webauthn-${currentContainer.type}` }, renderFidoContainer(currentContainer)));
                    break;
                }
                case "client-certificate": {
                    html.push(React.createElement(React.Fragment, { key: `client-certificate-${currentContainer.type}` }, renderCertificateContainer(currentContainer)));
                    break;
                }
            }
        }
        return html;
    };
    const classes = `${styles.accountContainer} ${styles.mainContainer} ${styles.content}`;
    return React.createElement("div", { id: "account-content", className: classes },
        renderAccountPageHeader(),
        React.createElement("div", { id: "account-data", className: styles.accountData },
            renderAccountUserDataForm(state, handleEmailChange, getPasswordUpdateAction, keycloak),
            Array.from(credentialContainers.keys())
                .filter((e, i, a) => e !== "basic-authentication" || keycloak.hasRealmRole("webauthn_user"))
                .map(category => (renderType(credentialContainers.get(category))))));
};
export default AccountDataPage;
